module.exports = function(collectionManager) {

	var _t = this;

	on(collectionManager, 'change').then(function() {
		_t.toggleIntro();
	});

	on(collectionManager, 'restore').then(function() {
		_t.toggleIntro();
	});

	this.toggleIntro = function() {
		if (collectionManager.items.length == 0) {
			this.classList.add('active');
		} else {
			this.classList.remove('active');
		}
	};

	this.toggleIntro();

};
